import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Modal,
  Backdrop,
  FormControl,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";

import axiosInstance from '../services/axiosConfig';
import "./CSS/vrfkat2.css";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";

import { useEffect } from "react";

import { Input } from "@mui/material";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_vrf2_tags,
  set_vrf4_tags,
  set_external_trend_info,
  set_combine_trends,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    flex: 1,
    gap: "3px",

    marginTop: "13%",
    marginLeft: "1%",
  },

  topButtonContainer: {
    position: "absolute",
    top: "4%",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
  },

  pageroot: {
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "relative",
  },

  lockButton: {
    marginLeft: theme.spacing(1),
  },
  floorTitle: {
    position: "absolute",
    top: "9%",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "2rem !important",
    fontWeight: 600,
    color: "black",
    padding: theme.spacing(1),
  },
  navigationButtonForward: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  navigationButtonBack: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  button: {
    backgroundColor: "lightgray",
    border: "2px solid rgb(67, 51, 22)",
    height: "5rem",
    width: "16rem",
    fontSize: "0.8rem",
    fontWeight: 700,

    whiteSpace: "nowrap",

    borderRadius: "20px",
    "&:focus": {
      outline: "none",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid rgb(237, 188, 69)",
    boxShadow: theme.shadows[5],
    maxWidth: 400,
    minWidth: 350,
    padding: theme.spacing(2, 5.5, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "3rem",
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  sogutmaısıtma: {
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  statusLabel: {
    marginRight: theme.spacing(2),
    minWidth: "150px",
    fontWeight: 600,
  },
  formControl: {
    flexGrow: 1,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
}));

const initalState = [
  {
    201: [
      { text: "Oda Sıcaklığı", tagId: "5055" },
      { text: "Oda Set Değeri", tagId: "5244", device: "10015" },
      { text: "Cihaz", tagId: "5450", tagId2: "5539", device: "10012" },
      { text: "Çalışma Modu", tagId: "6731", tagId2: "6877", device: "10013" },
      { text: "Çalışma Durumu", tagId: "6731", tagId2: "6877" },

      { text: "Fan Modu", tagId: "6732", tagId2: "6878" },
      { text: "Soğutma Modu Set Değeri", tagId: "5245" },
      { text: "Isıtma Modu Set Değeri", tagId: "5246" },
      { text: "Filtre Durumu", tagId: "5452" },
      { text: "Filtre Reset", tagId: "5728" },
      { text: "Arıza Durumu", tagId: "8643" },
      { text: "Arıza Kodu", tagId: "6730" },
    ],
  },
  {
    202: [
      { text: "Oda Sıcaklığı", tagId: "5056" },
      { text: "Oda Set Değeri", tagId: "5250", device: "10021" },
      { text: "Cihaz", tagId: "5454", tagId2: "5540", device: "10018" },
      { text: "Çalışma Modu", tagId: "6735", tagId2: "6880", device: "10019" },
      { text: "Çalışma Durumu", tagId: "6735", tagId2: "6880" },

      { text: "Fan Modu", tagId: "6736", tagId2: "6881" },
      { text: "Soğutma Modu Set Değeri", tagId: "5251" },
      { text: "Isıtma Modu Set Değeri", tagId: "5252" },
      { text: "Filtre Durumu", tagId: "5456" },
      { text: "Filtre Reset", tagId: "5734" },
      { text: "Arıza Durumu", tagId: "8647" },
      { text: "Arıza Kodu", tagId: "6734" },
    ],
  },
  {
    203: [
      { text: "Oda Sıcaklığı", tagId: "5057" },
      { text: "Oda Set Değeri", tagId: "5256", device: "10027" },
      { text: "Cihaz", tagId: "5458", tagId2: "5541", device: "10024" },
      { text: "Çalışma Modu", tagId: "6739", tagId2: "6883", device: "10025" },
      { text: "Çalışma Durumu", tagId: "6739", tagId2: "6883" },

      { text: "Fan Modu", tagId: "6740", tagId2: "6884" },
      { text: "Soğutma Modu Set Değeri", tagId: "5257" },
      { text: "Isıtma Modu Set Değeri", tagId: "5258" },
      { text: "Filtre Durumu", tagId: "5460" },
      { text: "Filtre Reset", tagId: "5740" },
      { text: "Arıza Durumu", tagId: "8651" },
      { text: "Arıza Kodu", tagId: "6738" },
    ],
  },
  {
    204: [
      { text: "Oda Sıcaklığı", tagId: "5058" },
      { text: "Oda Set Değeri", tagId: "5262", device: "10033" },
      { text: "Cihaz", tagId: "5462", tagId2: "5542", device: "10030" },
      { text: "Çalışma Modu", tagId: "6743", tagId2: "6886", device: "10031" },
      { text: "Çalışma Durumu", tagId: "6743", tagId2: "6886" },

      { text: "Fan Modu", tagId: "6744", tagId2: "6887" },
      { text: "Soğutma Modu Set Değeri", tagId: "5263" },
      { text: "Isıtma Modu Set Değeri", tagId: "5264" },
      { text: "Filtre Durumu", tagId: "5464" },
      { text: "Filtre Reset", tagId: "5746" },
      { text: "Arıza Durumu", tagId: "8655" },
      { text: "Arıza Kodu", tagId: "6742" },
    ],
  },
  {
    205: [
      { text: "Oda Sıcaklığı", tagId: "5059" },
      { text: "Oda Set Değeri", tagId: "5268", device: "10039" },
      { text: "Cihaz", tagId: "5466", tagId2: "5543", device: "10036" },
      { text: "Çalışma Modu", tagId: "6747", tagId2: "6889", device: "10037" },
      { text: "Çalışma Durumu", tagId: "6747", tagId2: "6889" },

      { text: "Fan Modu", tagId: "6748", tagId2: "6890" },
      { text: "Soğutma Modu Set Değeri", tagId: "5269" },
      { text: "Isıtma Modu Set Değeri", tagId: "5270" },
      { text: "Filtre Durumu", tagId: "5468" },
      { text: "Filtre Reset", tagId: "5752" },
      { text: "Arıza Durumu", tagId: "8659" },
      { text: "Arıza Kodu", tagId: "6746" },
    ],
  },
  {
    206: [
      { text: "Oda Sıcaklığı", tagId: "5060" },
      { text: "Oda Set Değeri", tagId: "5274", device: "10045" },
      { text: "Cihaz", tagId: "5470", tagId2: "5544", device: "10042" },
      { text: "Çalışma Modu", tagId: "6751", tagId2: "6892", device: "10043" },
      { text: "Çalışma Durumu", tagId: "6751", tagId2: "6892" },

      { text: "Fan Modu", tagId: "6752", tagId2: "6893" },
      { text: "Soğutma Modu Set Değeri", tagId: "5275" },
      { text: "Isıtma Modu Set Değeri", tagId: "5276" },
      { text: "Filtre Durumu", tagId: "5472" },
      { text: "Filtre Reset", tagId: "5758" },
      { text: "Arıza Durumu", tagId: "8663" },
      { text: "Arıza Kodu", tagId: "6750" },
    ],
  },
  {
    207: [
      { text: "Oda Sıcaklığı", tagId: "5061" },
      { text: "Oda Set Değeri", tagId: "5280", device: "10051" },
      { text: "Cihaz", tagId: "5474", tagId2: "5545", device: "10048" },
      { text: "Çalışma Modu", tagId: "6755", tagId2: "6895", device: "10049" },
      { text: "Çalışma Durumu", tagId: "6755", tagId2: "6895" },

      { text: "Fan Modu", tagId: "6756", tagId2: "6896" },
      { text: "Soğutma Modu Set Değeri", tagId: "5281" },
      { text: "Isıtma Modu Set Değeri", tagId: "5282" },
      { text: "Filtre Durumu", tagId: "5476" },
      { text: "Filtre Reset", tagId: "5764" },
      { text: "Arıza Durumu", tagId: "8667" },
      { text: "Arıza Kodu", tagId: "6754" },
    ],
  },
  {
    208: [
      { text: "Oda Sıcaklığı", tagId: "5062" },
      { text: "Oda Set Değeri", tagId: "5286", device: "10057" },
      { text: "Cihaz", tagId: "5478", tagId2: "5546", device: "10054" },
      { text: "Çalışma Modu", tagId: "6759", tagId2: "6898", device: "10055" },
      { text: "Çalışma Durumu", tagId: "6759", tagId2: "6898" },

      { text: "Fan Modu", tagId: "6760", tagId2: "6899" },
      { text: "Soğutma Modu Set Değeri", tagId: "5287" },
      { text: "Isıtma Modu Set Değeri", tagId: "5288" },
      { text: "Filtre Durumu", tagId: "5480" },
      { text: "Filtre Reset", tagId: "5770" },
      { text: "Arıza Durumu", tagId: "8671" },
      { text: "Arıza Kodu", tagId: "6758" },
    ],
  },
  {
    209: [
      { text: "Oda Sıcaklığı", tagId: "5063" },
      { text: "Oda Set Değeri", tagId: "5292", device: "10063" },
      { text: "Cihaz", tagId: "5482", tagId2: "5547", device: "10060" },
      { text: "Çalışma Modu", tagId: "6763", tagId2: "6901", device: "10061" },
      { text: "Çalışma Durumu", tagId: "6763", tagId2: "6901" },

      { text: "Fan Modu", tagId: "6764", tagId2: "6902" },
      { text: "Soğutma Modu Set Değeri", tagId: "5293" },
      { text: "Isıtma Modu Set Değeri", tagId: "5294" },
      { text: "Filtre Durumu", tagId: "5484" },
      { text: "Filtre Reset", tagId: "5776" },
      { text: "Arıza Durumu", tagId: "8675" },
      { text: "Arıza Kodu", tagId: "6762" },
    ],
  },
  {
    210: [
      { text: "Oda Sıcaklığı", tagId: "5064" },
      { text: "Oda Set Değeri", tagId: "5298", device: "10069" },
      { text: "Cihaz", tagId: "5486", tagId2: "5548", device: "10066" },
      { text: "Çalışma Modu", tagId: "6767", tagId2: "6904", device: "10067" },
      { text: "Çalışma Durumu", tagId: "6767", tagId2: "6904" },

      { text: "Fan Modu", tagId: "6768", tagId2: "6905" },
      { text: "Soğutma Modu Set Değeri", tagId: "5299" },
      { text: "Isıtma Modu Set Değeri", tagId: "5300" },
      { text: "Filtre Durumu", tagId: "5488" },
      { text: "Filtre Reset", tagId: "5782" },
      { text: "Arıza Durumu", tagId: "8679" },
      { text: "Arıza Kodu", tagId: "6766" },
    ],
  },
  {
    211: [
      { text: "Oda Sıcaklığı", tagId: "5065" },
      { text: "Oda Set Değeri", tagId: "5304", device: "10075" },
      { text: "Cihaz", tagId: "5490", tagId2: "5549", device: "10072" },
      { text: "Çalışma Modu", tagId: "6771", tagId2: "6907", device: "10073" },
      { text: "Çalışma Durumu", tagId: "6771", tagId2: "6907" },

      { text: "Fan Modu", tagId: "6772", tagId2: "6908" },
      { text: "Soğutma Modu Set Değeri", tagId: "5305" },
      { text: "Isıtma Modu Set Değeri", tagId: "5306" },
      { text: "Filtre Durumu", tagId: "5492" },
      { text: "Filtre Reset", tagId: "5788" },
      { text: "Arıza Durumu", tagId: "8683" },
      { text: "Arıza Kodu", tagId: "6770" },
    ],
  },
  {
    212: [
      { text: "Oda Sıcaklığı", tagId: "5066" },
      { text: "Oda Set Değeri", tagId: "5310", device: "10081" },
      { text: "Cihaz", tagId: "5494", tagId2: "5550", device: "10078" },
      { text: "Çalışma Modu", tagId: "6775", tagId2: "6910", device: "10079" },
      { text: "Çalışma Durumu", tagId: "6775", tagId2: "6910" },

      { text: "Fan Modu", tagId: "6776", tagId2: "6911" },
      { text: "Soğutma Modu Set Değeri", tagId: "5311" },
      { text: "Isıtma Modu Set Değeri", tagId: "5312" },
      { text: "Filtre Durumu", tagId: "5496" },
      { text: "Filtre Reset", tagId: "5794" },
      { text: "Arıza Durumu", tagId: "8687" },
      { text: "Arıza Kodu", tagId: "6774" },
    ],
  },
  {
    213: [
      { text: "Oda Sıcaklığı", tagId: "5067" },
      { text: "Oda Set Değeri", tagId: "5316", device: "10087" },
      { text: "Cihaz", tagId: "5498", tagId2: "5551", device: "10084" },
      { text: "Çalışma Modu", tagId: "6779", tagId2: "6913", device: "10085" },
      { text: "Çalışma Durumu", tagId: "6779", tagId2: "6913" },

      { text: "Fan Modu", tagId: "6780", tagId2: "6914" },
      { text: "Soğutma Modu Set Değeri", tagId: "5317" },
      { text: "Isıtma Modu Set Değeri", tagId: "5318" },
      { text: "Filtre Durumu", tagId: "5500" },
      { text: "Filtre Reset", tagId: "5800" },
      { text: "Arıza Durumu", tagId: "8691" },
      { text: "Arıza Kodu", tagId: "6778" },
    ],
  },
  {
    214: [
      { text: "Oda Sıcaklığı", tagId: "5068" },
      { text: "Oda Set Değeri", tagId: "5322", device: "10093" },
      { text: "Cihaz", tagId: "5502", tagId2: "5552", device: "10090" },
      { text: "Çalışma Modu", tagId: "6783", tagId2: "6916", device: "10091" },
      { text: "Çalışma Durumu", tagId: "6783", tagId2: "6916" },

      { text: "Fan Modu", tagId: "6784", tagId2: "6917" },
      { text: "Soğutma Modu Set Değeri", tagId: "5323" },
      { text: "Isıtma Modu Set Değeri", tagId: "5324" },
      { text: "Filtre Durumu", tagId: "5504" },
      { text: "Filtre Reset", tagId: "5806" },
      { text: "Arıza Durumu", tagId: "8695" },
      { text: "Arıza Kodu", tagId: "6782" },
    ],
  },
];

let revisedState = {};

initalState.forEach((room) => {
  const roomId = Object.keys(room)[0];
  const roomTags = room[roomId];

  roomTags.forEach((tag) => {
    const text = tag.text;
    const tagId = tag.tagId;

    if (!revisedState[text]) {
      revisedState[text] = [];
    }

    revisedState[text].push(tagId);
  });
});

const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  initalState.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
      // tagId2 varsa onu da ekleyelim
      if (item3.tagId2) {
        obj2__.push({ tagId: item3.tagId2 });
      }else if(item3.device)               obj2__.push({ tagId: item3.device });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/vrf2") {
        try {
          const request = await axiosInstance.post(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            obj2__
          );
          const response = request.data;

          const updatedResponse = response.map((item) => {
            const matchedItem = obj2__.find(
              (objItem) => objItem.tagId === item.tagId
            );
            return {
              ...item,
              tagId2: matchedItem ? matchedItem.tagId : null,
            };
          });

          Store.dispatch(set_vrf2_tags(response));
        } catch (err) {
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 1000);
};

setTimeout(() => {
  inital_func();
}, 100);

const VRF2 = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(Array(14).fill(false));

  const [state, Set_state] = useState(initalState);
  const [render_state, Set_render_state] = useState([]);

  useEffect(() => {
    Set_render_state(props.vrf2_tags);
  }, [props.vrf2_tags]);

  const [locked, setLocked] = useState({
    201: { odasetdegeri: false },
    202: { odasetdegeri: false },
    203: { odasetdegeri: false },
    204: { odasetdegeri: false },
    205: { odasetdegeri: false },
    206: { odasetdegeri: false },
    207: { odasetdegeri: false },
    208: { odasetdegeri: false },
    209: { odasetdegeri: false },
    210: { odasetdegeri: false },
    211: { odasetdegeri: false },
    212: { odasetdegeri: false },
    213: { odasetdegeri: false },
    214: { odasetdegeri: false },
  });

  const [active_rm2, Set_active_rm2] = useState(false); // render modal 2

  //yetkilendirme
  const [vrf_okuma_control, Set_vrf_okuma_control] = useState(false);

  useEffect(() => {
    if (props.yetkilendirme && props.uid !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.uid];
      if (newObj !== undefined) {
        if (newObj["VRF"]["Y"] === "t") {
          Set_vrf_okuma_control(true);
        } else {
          Set_vrf_okuma_control(false);
        }
      }
    }
  }, [props.yetkilendirme]);

  const toggleLock = (roomNumber, selectType) => {
    setLocked((prevLocked) => {
      const newLocked = {
        ...prevLocked,
        [roomNumber]: {
          ...prevLocked[roomNumber],
          [selectType]: !prevLocked[roomNumber]?.[selectType],
        },
      };
      return newLocked;
    });
  };

  const [active_room_number, Set_active_room_number] = useState(null);

  const handleOpen = (index) => {
    let newOpen = [...open];
    newOpen[index] = true;
    setOpen(newOpen);
  };

  const handleClose = (roomNumber) => {
    const index = roomNumber - 201;
    let newOpen = [...open];
    newOpen[index] = false;
    setOpen(newOpen);
    Set_active_room_number(null);
  };

  const [cihazselectValue, setcihazSelectValue] = useState({
    201: "ON",
    202: "ON",
    203: "ON",
    204: "ON",
    205: "ON",
    206: "ON",
    207: "ON",
    208: "ON",
    209: "ON",
    210: "ON",
    211: "ON",
    212: "ON",
    213: "ON",
    214: "ON",
  });

  const CihazSelectChange = (event) => {
    setcihazSelectValue(event.target.value);
  };
  const [calismamoduselectValue, setcalismamoduSelectValue] = useState({
    201: "ISITMA",
    202: "ISITMA",
    203: "ISITMA",
    204: "ISITMA",
    205: "ISITMA",
    206: "ISITMA",
    207: "ISITMA",
    208: "ISITMA",
    209: "ISITMA",
    210: "ISITMA",
    211: "ISITMA",
    212: "ISITMA",
    213: "ISITMA",
    214: "ISITMA",
  });

  const CalismaModuSelectChange = (event, roomNumber) => {
    var newObj = calismamoduselectValue;
    newObj[roomNumber] = event.target.value;

    setcalismamoduSelectValue(newObj);
  };
  const [fanmoduselectValue, setfanmoduSelectValue] = useState({
    201: "1 ",
    202: "1 ",
    203: "1 ",
    204: "1 ",
    205: "1 ",
    206: "1 ",
    207: "1 ",
    208: "1 ",
    209: "1 ",
    210: "1 ",
    211: "1 ",
    212: "1 ",
    213: "1 ",
    214: "1 ",
  });
  const [filtredurumselectValue, setfiltreselectSelectValue] = useState({
    201: "TEMİZ",
    202: "TEMİZ",
    203: "TEMİZ",
    204: "TEMİZ",
    205: "TEMİZ",
    206: "TEMİZ",
    207: "TEMİZ",
    208: "TEMİZ",
    209: "TEMİZ",
    210: "TEMİZ",
    211: "TEMİZ",
    212: "TEMİZ",
    213: "TEMİZ",
    214: "TEMİZ",
  });
  const [arızadurumselectValue, setarızadurumSelectValue] = useState("NORMAL");
  const [arızakoduselectValue, setarızakoduSelectValue] = useState("0");

  const FanModuSelectChange = (event) => {
    setfanmoduSelectValue(event.target.value);
  };
  const FiltreDurumSelectChange = (event) => {
    setfiltreselectSelectValue(event.target.value);
  };
  const ArızaDurumSelectChange = (event) => {
    setarızadurumSelectValue(event.target.value);
  };
  const ArızaKoduSelectChange = (event) => {
    const selectedArızaKodu = event.target.value;
    setarızakoduSelectValue(selectedArızaKodu);

    if (selectedArızaKodu === "0") {
      setarızadurumSelectValue("NORMAL");
    } else if (selectedArızaKodu === "1") {
      setarızadurumSelectValue("ALARM");
    }
  };

  const initialOdaSetDegerler = {
    201: "25",
    202: "25",
    203: "25",
    204: "25",
    205: "25",
    206: "25",
    207: "25",
    208: "25",
    209: "25",
    210: "25",
    211: "25",
    212: "25",
    213: "25",
    214: "25",
  };

  const initialSogutmamoduSet = {
    201: "19",
    202: "19",
    203: "19",
    204: "19",
    205: "19",
    206: "19",
    207: "19",
    208: "19",
    209: "19",
    210: "19",
    211: "19",
    212: "19",
    213: "19",
    214: "19",
  };
  const initialSogutmamoduUst = {
    201: "22",
    202: "22",
    203: "22",
    204: "22",
    205: "22",
    206: "22",
    207: "22",
    208: "22",
    209: "22",
    210: "22",
    211: "22",
    212: "22",
    213: "22",
    214: "22",
  };
  const initialSogutmamoduAlt = {
    201: "18",
    202: "18",
    203: "18",
    204: "18",
    205: "18",
    206: "18",
    207: "18",
    208: "18",
    209: "18",
    210: "18",
    211: "18",
    212: "18",
    213: "18",
    214: "18",
  };
  const initialIsıtmamoduSet = {
    201: "28",
    202: "28",
    203: "28",
    204: "28",
    205: "28",
    206: "28",
    207: "28",
    208: "28",
    209: "28",
    210: "28",
    211: "28",
    212: "28",
    213: "28",
    214: "28",
  };
  const initialIsıtmamoduUst = {
    201: "30",
    202: "30",
    203: "30",
    204: "30",
    205: "30",
    206: "30",
    207: "30",
    208: "30",
    209: "30",
    210: "30",
    211: "30",
    212: "30",
    213: "30",
    214: "30",
  };
  const initialIsıtmamoduAlt = {
    201: "26",
    202: "26",
    203: "26",
    204: "26",
    205: "26",
    206: "26",
    207: "26",
    208: "26",
    209: "26",
    210: "26",
    211: "26",
    212: "26",
    213: "26",
    214: "26",
  };

  const [lock, Setlock] = useState({
    201: "0",
    202: "0",
    203: "0",
    204: "0",
    205: "0",
    206: "0",
    207: "0",
    208: "0",
    209: "0",
    210: "0",
    211: "0",
    212: "0",
    213: "0",
    214: "0",
  });

  const [lock2, Setlock2] = useState({
    201: "0",
    202: "0",
    203: "0",
    204: "0",
    205: "0",
    206: "0",
    207: "0",
    208: "0",
    209: "0",
    210: "0",
    211: "0",
    212: "0",
    213: "0",
    214: "0",
  });

  const [lock3, Setlock3] = useState({
    201: "0",
    202: "0",
    203: "0",
    204: "0",
    205: "0",
    206: "0",
    207: "0",
    208: "0",
    209: "0",
    210: "0",
    211: "0",
    212: "0",
    213: "0",
    214: "0",
  });

  const [setDegerleri, SETSetDegerleri] = useState(false);

  const [odasetdegerler, setOdasetdegerler] = useState(initialOdaSetDegerler);
  const [initialOdasetdegerler, setInitialOdasetdegerler] = useState(
    initialOdaSetDegerler
  );
  const [sogutmamoduSet, SetsogutmamoduSet] = useState(initialSogutmamoduSet);
  const [initialSogutmaModuSet, setInitialSogutmamoduSet] = useState(
    initialSogutmamoduSet
  );
  const [sogutmamoduUst, SetsogutmamoduUst] = useState(initialSogutmamoduUst);
  const [initialSogutmaModuUst, setInitialSogutmamoduUst] = useState(
    initialSogutmamoduUst
  );
  const [sogutmamoduAlt, SetsogutmamoduAlt] = useState(initialSogutmamoduAlt);
  const [initialSogutmaModuAlt, setInitialSogutmamoduAlt] = useState(
    initialSogutmamoduAlt
  );
  const [ısıtmamoduSet, SetısıtmamoduSet] = useState(initialIsıtmamoduSet);
  const [initialIsıtmaModuSet, setInitialIsıtmamoduSet] =
    useState(initialIsıtmamoduSet);
  const [ısıtmamoduUst, SetısıtmamoduUst] = useState(initialIsıtmamoduUst);
  const [initialIsıtmaModuUst, setInitialIsıtmamoduUst] =
    useState(initialIsıtmamoduUst);
  const [ısıtmamoduAlt, SetısıtmamoduAlt] = useState(initialIsıtmamoduAlt);
  const [initialIsıtmaModuAlt, setInitialIsıtmamoduAlt] =
    useState(initialIsıtmamoduAlt);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  const [cihazled, Setcihazled] = useState({
    201: "green",
    202: "green",
    203: "green",
    204: "green",
    205: "green",
    206: "green",
    207: "green",
    208: "green",
    209: "green",
    210: "green",
    211: "green",
    212: "green",
    213: "green",
    214: "green",
  });

  useEffect(() => {
    if (props.vrf2_tags.length > 0) {
      const inital_func = () => {
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            }else if(item3.device)               obj2__.push({ tagId: item3.device });

          });
        });

        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrf2") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              response.forEach(a=>{
                if(Number(a.tagId)>10000){
                  console.warn(a)
                }
              })

              const updatedResponse = response.map((item) => {
                const matchedItem = obj2__.find(
                  (objItem) => objItem.tagId === item.tagId
                );
                return {
                  ...item,
                  tagId2: matchedItem ? matchedItem.tagId : null,
                };
              });

              Store.dispatch(set_vrf2_tags(response));
              Set_render_state(response);
            } catch (err) {
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };
        fetch_tag_values();
      };

      inital_func();

      var title = [];
      var title2 = [];
      var title3 = [];
      var tag_values_set = [];
      var tag_values_set2 = [];
      var tag_values_set3 = [];
      var tag_values_calisma = [];
      var tag_values_cihaz = [];
      var tag_values_fan = [];
      var tag_values_led = [];
      var tag_values_filtre = [];
      var tag_lock = [];
      var tag_lock2 = [];

      var tag_lock3 = [];

      var newdata = [];
      var newdata2 = [];
      var newdata3 = [];

      state.map((item, index) => {
        var obj_ = [];
        Object.entries(item).forEach((a) => {
          title.push(a[0]);
          title2.push(a[0]);
          title3.push(a[0]);

          obj_.push(a[1]);
        });
        obj_[0].forEach((item_) => {
          props.vrf2_tags.forEach((item2) => {
            if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              tag_values_set.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Soğutma Modu Set Değeri"
            ) {
              tag_values_set2.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_lock.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              tag_lock3.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              tag_lock2.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Isıtma Modu Set Değeri"
            ) {
              tag_values_set3.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              console.log(item2.tagValue, item2.tagId);
              tag_values_calisma.push(
                item2.tagValue.trim() === "2"
                  ? "ISITMA"
                  : item2.tagValue.trim() === "1"
                  ? "SOĞUTMA"
                  : item2.tagValue.trim() === "5"
                  ? "NEM ALMA"
                  : item2.tagValue.trim() === "3"
                  ? "FAN"
                  : "AUTO"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_values_cihaz.push(
                item2.tagValue.trim() === "0" ? "OFF" : "ON"
              );
              tag_values_led.push(
                item2.tagValue.trim() === "0" ? "gray" : "green"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Fan Modu"
            ) {
              const valueMapping = {
                1: "DÜŞÜK",
                2: "HIZLI",
                3: "ORTA 2",
                4: "ORTA",
                5: "AUTO",
              };

              tag_values_fan.push(
                valueMapping[item2.tagValue.trim()] || item2.tagValue.trim()
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Filtre Durumu"
            ) {
              console.log(item2.tagValue);
              tag_values_filtre.push(
                item2.tagValue.trim() === "1" ? "TEMİZ" : "KİRLİ"
              );
            }
          });
        });
      });

      var obj2_5 = {
        201: "green",
        202: "green",
        203: "green",
        204: "green",
        205: "green",
        206: "green",
        207: "green",
        208: "green",
        209: "green",
        210: "green",
        211: "green",
        212: "green",
        213: "green",
        214: "green",
      };
      var obj2_2 = {
        201: "ISITMA",
        202: "ISITMA",
        203: "ISITMA",
        204: "ISITMA",
        205: "ISITMA",
        206: "ISITMA",
        207: "ISITMA",
        208: "ISITMA",
        209: "ISITMA",
        210: "ISITMA",
        211: "ISITMA",
        212: "ISITMA",
        213: "ISITMA",
        214: "ISITMA",
      };

      var obj2_3 = {
        201: "ON",
        202: "ON",
        203: "ON",
        204: "ON",
        205: "ON",
        206: "ON",
        207: "ON",
        208: "ON",
        209: "ON",
        210: "ON",
        211: "ON",
        212: "ON",
        213: "ON",
        214: "ON",
      };

      var obj2_7 = {
        201: "TEMİZ",
        202: "TEMİZ",
        203: "TEMİZ",
        204: "TEMİZ",
        205: "TEMİZ",
        206: "TEMİZ",
        207: "TEMİZ",
        208: "TEMİZ",
        209: "TEMİZ",
        210: "TEMİZ",
        211: "TEMİZ",
        212: "TEMİZ",
        213: "TEMİZ",
        214: "TEMİZ",
      };

      var obj2_lock = {
        201: "0",
        202: "0",
        203: "0",
        204: "0",
        205: "0",
        206: "0",
        207: "0",
        208: "0",
        209: "0",
        210: "0",
        211: "0",
        212: "0",
        214: "0",
      };

      var obj2_lock2 = {
        201: "0",
        202: "0",
        203: "0",
        204: "0",
        205: "0",
        206: "0",
        207: "0",
        208: "0",
        209: "0",
        210: "0",
        211: "0",
        212: "0",
        214: "0",
      };

      var obj2_lock3 = {
        201: "0",
        202: "0",
        203: "0",
        204: "0",
        205: "0",
        206: "0",
        207: "0",
        208: "0",
        209: "0",
        210: "0",
        211: "0",
        212: "0",
        214: "0",
      };

      var obj2_4 = {
        201: "1 ",
        202: "1 ",
        203: "1 ",
        204: "1 ",
        205: "1 ",
        206: "1 ",
        207: "1 ",
        208: "1 ",
        209: "1 ",
        210: "1 ",
        211: "1 ",
        212: "1 ",
        213: "1 ",
        214: "1 ",
      };

      for (let i = 0; i < title.length; i++) {
        newdata[title[i]] = tag_values_set[i].trim();
      }
      for (let i = 0; i < title2.length; i++) {
        newdata2[title2[i]] = tag_values_set2[i].trim();
      }
      for (let i = 0; i < title3.length; i++) {
        newdata3[title3[i]] = tag_values_set3[i].trim();
      }

      for (let k = 0; k < 14; k++) {
        obj2_2[String(k + 201)] = tag_values_calisma[k];
      }

      for (let k = 0; k < 14; k++) {
        obj2_3[String(k + 201)] = tag_values_cihaz[k];
      }

      for (let k = 0; k < 14; k++) {
        obj2_4[String(k + 201)] = tag_values_fan[k];
      }

      for (let k = 0; k < 14; k++) {
        obj2_5[String(k + 201)] = tag_values_led[k];
      }

      for (let k = 0; k < 14; k++) {
        obj2_7[String(k + 201)] = tag_values_filtre[k];
      }

      for (let k = 0; k < 14; k++) {
        obj2_lock[String(k + 201)] = tag_lock[k];
      }
      for (let k = 0; k < 14; k++) {
        obj2_lock2[String(k + 201)] = tag_lock2[k];
      }
      for (let k = 0; k < 14; k++) {
        obj2_lock3[String(k + 201)] = tag_lock3[k];
      }

      setOdasetdegerler(newdata);
      SetsogutmamoduSet(newdata2);
      SetısıtmamoduSet(newdata3);

      Setcihazled(obj2_5);
      setfanmoduSelectValue(obj2_4);
      setcihazSelectValue(obj2_3);
      setcalismamoduSelectValue(obj2_2);

      Setlock(obj2_lock);
      Setlock2(obj2_lock2);
      Setlock3(obj2_lock3);

      setfiltreselectSelectValue(obj2_7);
    }
  }, []);

  const handleInputChange = (roomNumber, type) => (event) => {
    const newValue =
      event.target.value === ""
        ? ""
        : Math.max(18, Math.min(30, Number(event.target.value)));

    switch (type) {
      case "odasetdeger":
        setOdasetdegerler((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduSet":
        SetsogutmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduUst":
        SetsogutmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduAlt":
        SetsogutmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduSet":
        SetısıtmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduUst":
        SetısıtmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduAlt":
        SetısıtmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
  }, []);

  useEffect(() => {}, [cihazselectValue]);

  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const [isEditing4, setIsEditing4] = useState(false);
  const [isEditing5, setIsEditing5] = useState(false);
  const [isEditing6, setIsEditing6] = useState(false);

  const handleEditStart1 = () => {
    setIsEditing1(true);
  };
  const handleEditStart2 = () => {
    setIsEditing2(true);
  };
  const handleEditStart3 = () => {
    setIsEditing3(true);
  };
  const handleEditStart4 = () => {
    setIsEditing4(true);
  };
  const handleEditStart5 = () => {
    setIsEditing5(true);
  };
  const handleEditStart6 = () => {
    setIsEditing6(true);
  };

  const handleEditCancel1 = () => {
    setIsEditing1(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone1 = () => {
    setIsEditing1(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel2 = () => {
    setIsEditing2(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone2 = () => {
    setIsEditing2(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel3 = () => {
    setIsEditing3(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone3 = () => {
    setIsEditing3(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel4 = () => {
    setIsEditing4(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone4 = () => {
    setIsEditing4(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel5 = () => {
    setIsEditing5(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone5 = () => {
    setIsEditing5(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel6 = () => {
    setIsEditing6(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone6 = () => {
    setIsEditing6(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };

  const history = useHistory();

  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {}
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {}
  };

  const sendSetValueFunc = async (list_) => {
    try {
      console.log("sendSetValueFunc çağrıldı", list_);

      // API çağrısını yap
      const req = await axiosInstance.post(
        "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
        list_
      );

      // API yanıtını işle
      const response = req.data;
      console.log("API yanıtı:", response);
      console.log("HTTP durum kodu:", req.status);

      if (req.status === 200) {
        console.log("API çağrısı başarılı, verileri güncelleniyor.");

        // Tag değerlerini al
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            }else if(item3.device)               obj2__.push({ tagId: item3.device });
          });
        });

        console.log("Tag ID'leri:", obj2__);

        // Tag değerlerini al ve güncelle
        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrf2") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              // Gelen yanıtın içerisinde tagId2'leri bulup ekliyoruz
              const updatedResponse = response.map((item) => {
                const matchedItem = obj2__.find(
                  (objItem) => objItem.tagId === item.tagId
                );
                return {
                  ...item,
                  tagId2: matchedItem ? matchedItem.tagId : null,
                };
              });

              console.log("Tag değerleri alındı:", response);

              Store.dispatch(set_vrf2_tags(response));
            } catch (err) {
              console.log("Tag değerleri fetch hatası:", err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };

        await fetch_tag_values();
      } else {
        console.log("API çağrısı başarısız:", req.status);
      }
    } catch (error) {
      console.log("sendSetValueFunc hatası:", error);
    }
  };

  const handleOdaSetDegeriDone = (roomNumber) => {
    const updatedValue = String(odasetdegerler[roomNumber]);
    let tagId;

    state.forEach((item) => {
      if (item[String(roomNumber)]) {
        tagId = item[String(roomNumber)].find(
          (x) => x.text === "Oda Set Değeri"
        )?.tagId;
      }
    });

    if (tagId) {
      sendSetValueFunc({
        TagId: String(tagId),
        TagValue: updatedValue,
      });
    }
  };

  const [active, Set_active] = useState(false);

  const [changed_values, Set_changed_values] = useState([]);
  const [changed_values2, Set_changed_values2] = useState([]);

  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Isıtma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Isıtma"]);
    }
  }, [ısıtmamoduSet]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Soğutma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Soğutma"]);
    }
  }, [sogutmamoduSet]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("SET" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "SET"]);
    }
  }, [odasetdegerler]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Çalışma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Çalışma"]);
    }
  }, [calismamoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Fan" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Fan"]);
    }
  }, [fanmoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Cihaz" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Cihaz"]);
    }
  }, [cihazselectValue]);

  const genel_value_changes = (type, value) => {
    let newdata = changed_values2;
    var toplam_ = 0;
    for (let i of newdata) {
      if (type === i.type) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values2((Prevvalues) => [
        ...Prevvalues,
        { type: type, value: value },
      ]);
    }
  };

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
    setTimeout(() => {
      Set_changed_values([]);
      Set_changed_values2([]);
    }, 3000);
  }, []);

  const renderModalContent = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            handleClose(roomNumber);
            SETSetDegerleri(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{
            color: "rgb(28,28,28)",
            textAlign: "center",
          }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {`ODA ${roomNumber}`}
        </Typography>
        <div className="vrf-popup-select">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            if (title.length > 0 && obj_.length > 0) {
              return (
                <div style={{ width: "100%", marginRight: "16px" }}>
                  {obj_[0].map((x, index) => {
                    switch (x.text) {
                      case "Oda Sıcaklığı":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        const matchingTag = props.tag_list.find(
                          (tag) => tag.tagId === x.tagId
                        );

                        // Eğer eşleşen tag bulunduysa ve tagDecimal null değilse o değeri kullan, yoksa varsayılan 2 kullan
                        const decimalPlaces =
                          matchingTag && matchingTag.tagDecimal !== null
                            ? Number(matchingTag.tagDecimal)
                            : 2;

                        değerler_eleman =
                          decimalPlaces !== 0
                            ? Number(değerler_eleman).toFixed(decimalPlaces)
                            : Number(değerler_eleman).toFixed(2);

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;

                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-sicakligi-label`}
                                id={`oda${roomNumber}-oda-sicakligi-select`}
                                displayEmpty
                                IconComponent={() => null}
                                disabled={!vrf_okuma_control}
                              >
                                <MenuItem>
                                  <span
                                    style={{
                                      display: "flex",
                                      width: "83%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <em
                                      style={{ flex: 1, textAlign: "center" }}
                                    >
                                      {değerler_eleman}
                                    </em>
                                    <span
                                      style={{
                                        position: "relative",
                                        right: "7%",
                                        color: "rgba(0, 0, 0, 0.54)",
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                      }}
                                    >
                                      °C
                                    </span>
                                  </span>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div
                            className={classes.statusRow}
                            id="vrf_pop_up_row"
                          >
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                className="oda-set-degeri-padding"
                                id={`oda${roomNumber}-oda-set-degeri-input`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                value={odasetdegerler[roomNumber]}
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri(true);

                                  handleInputChange(
                                    roomNumber,
                                    "odasetdeger"
                                  )(e);
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][1].device;
                                  }
                                });
                                let value = String(
                                  lock3[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock3((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock3[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        // Normalize cihaz durumu value
                        var normalizedCihazDurumu = değerler_eleman !== undefined ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1") : "0";

                        var cihazDurumuText =
                          normalizedCihazDurumu === "0" ? "OFF" : "ON"; // Varsayılan ON olur

                        // tagId2 ve işlenmiş değerleri yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${değerler_eleman}, Mod: ${cihazDurumuText} CİHAZZZZZZ`
                        );

                        var cihazRengi =
                          normalizedCihazDurumu === "0" ? "gray" : "green";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor:
                                  cihazRengi || cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.device) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                  }
                                }}
                                id="cihaz_modu_div"
                                className="cihaz_modu_div"
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                              >
                                {cihazDurumuText ||
                                  cihazselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.device || (
                                <ul className="cihaz_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "green",
                                      }));

                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "green";
                                    }}
                                  >
                                    ON
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "gray",
                                      }));
                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "gray";
                                    }}
                                  >
                                    OFF
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][2].device;
                                  }
                                });
                                let value = String(
                                  lock[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Çalışma Modu":
                        // tagId2'lerin listesini tanımla
                        var tagId2ler = [
                          "6877",
                          "6880",
                          "6883",
                          "6886",
                          "6889",
                          "6892",
                          "6895",
                          "6898",
                          "6901",
                          "6904",
                          "6907",
                          "6910",
                          "6913",
                          "6916",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = değerler[0]; // Trimleme burada yapılıyor

                          // tagValue değerini işleme alıyoruz
                          var calismaModuText =
                            değerler_eleman === "2 "
                              ? "ISITMA"
                              : değerler_eleman === "1 "
                              ? "SOĞUTMA"
                              : değerler_eleman === "5 "
                              ? "NEM ALMA"
                              : değerler_eleman === "3 "
                              ? "FAN"
                              : "AUTO"; // Varsayılan AUTO olur

                          // tagId2 ve işlenmiş değerleri yazdır
                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${değerler_eleman}, Mod: ${calismaModuText}`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.mode) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                  }
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId2)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId2;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id="calisma_modu_div"
                                className="calisma_modu_div"
                              >
                                {calismaModuText ||
                                  calismamoduselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.mode || (
                                <ul className="calisma_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    ISITMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    SOĞUTMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    NEM ALMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    AUTO
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    FAN
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][3].device;
                                  }
                                });
                                let value = String(
                                  lock2[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock2((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock2[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // Çalışma Durumu
                      case "Çalışma Durumu":
                        // Filtrelenmiş tagId ve tagValue'leri al
                        var çalışmaModuDeğerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);

                        // İlk elemanı al
                        var çalışmaModuEleman = çalışmaModuDeğerler[0];

                        // TagId ve değerleri konsola yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${çalışmaModuEleman}`
                        );

                        // Rengi belirle
                        var çalışmaDurumuRengi =
                          çalışmaModuEleman === "1 "
                            ? "cornflowerblue"
                            : çalışmaModuEleman === "2 "
                            ? "red"
                            : "gray";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA DURUMU
                            </Typography>
                            <div
                              style={{
                                backgroundColor: çalışmaDurumuRengi,
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                position: "absolute",
                                left: "65%",
                              }}
                            ></div>
                          </div>
                        );

                      case "Fan Modu":
                        var tagId2ler = [
                          "6878",
                          "6881",
                          "6884",
                          "6887",
                          "6890",
                          "6893",
                          "6896",
                          "6899",
                          "6902",
                          "6905",
                          "6908",
                          "6911",
                          "6914",
                          "6917",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = değerler[0]; // Trimleme burada yapılıyor

                          var fanModuText =
                            değerler_eleman === "1 "
                              ? "DÜŞÜK"
                              : değerler_eleman === "2 "
                              ? "HIZLI"
                              : değerler_eleman === "3 "
                              ? "ORTA 2"
                              : değerler_eleman === "4 "
                              ? "ORTA"
                              : "AUTO"; // Varsayılan AUTO olur

                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${değerler_eleman}, Mod: ${fanModuText} FANNNN`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  borderRadius: "4px",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid #edbc45"
                                    : "2px solid #edbc45",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                id="fan_modu_div"
                                className="fan_modu_div"
                              >
                                {fanModuText ||
                                  fanmoduselectValue[String(roomNumber)]}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>

                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));
                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                opacity: "0",
                                position: "relative",
                                zIndex: "-1000000",
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Soğutma Modu Set Değeri":
                      // case "Isıtma Modu Set Değeri":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   const labelText = `${
                      //     x.text.toUpperCase().split(" ")[0]
                      //   } MODU <br> SET DEĞERİ`;
                      //   const inputId =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? `oda${roomNumber}-sogutma-modu-set-input`
                      //       : `oda${roomNumber}-isitma-modu-set-input`;
                      //   const inputValue =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? sogutmamoduSet[roomNumber]
                      //       : ısıtmamoduSet[roomNumber];
                      //   const handleInputChangeFunc =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? (e) =>
                      //           handleInputChange(
                      //             roomNumber,
                      //             "sogutmamoduSet"
                      //           )(e)
                      //       : (e) =>
                      //           handleInputChange(
                      //             roomNumber,
                      //             "ısıtmamoduSet"
                      //           )(e);

                      //   const lockedKey =
                      //     x.text === "Soğutma Modu Set Değeri"
                      //       ? "sogutmamoduSet"
                      //       : "ısıtmamoduSet";

                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //         dangerouslySetInnerHTML={{ __html: labelText }}
                      //       />
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //         style={{ minWidth: "60px" }}
                      //       >
                      //         <Input
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-${x.text
                      //             .toLowerCase()
                      //             .replace(/ /g, "-")}-label`}
                      //           className="oda-set-degeri-padding"
                      //           id={inputId}
                      //           sx={{ fontWeight: 600 }}
                      //           type="number"
                      //           disabled={
                      //             locked[roomNumber]?.[lockedKey] ||
                      //             !vrf_okuma_control
                      //           }
                      //           value={inputValue}
                      //           onChange={handleInputChangeFunc}
                      //           endAdornment={
                      //             <InputAdornment
                      //               className="vrf-derece"
                      //               position="end"
                      //             >
                      //               °C
                      //             </InputAdornment>
                      //           }
                      //         />
                      //       </FormControl>
                      //       <IconButton
                      //         onClick={() => toggleLock(roomNumber, lockedKey)}
                      //         className={classes.lockButton}
                      //       >
                      //         {locked[roomNumber]?.[lockedKey] ? (
                      //           <LockIcon />
                      //         ) : (
                      //           <LockOpenIcon />
                      //         )}
                      //       </IconButton>
                      //     </div>
                      //   );

                      // case "Filtre Durumu":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];

                      //   değerler_eleman =
                      //     değerler_eleman === "1 " ? "TEMİZ" : "KİRLİ";

                      //   değerler_eleman =
                      //     değerler_eleman === "1 " ? "TEMİZ" : "KİRLİ";

                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Select
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-durumu-label`}
                      //           id={`oda${roomNumber}-filtre-durumu-select`}
                      //           className="filtre-durum-class"
                      //           displayEmpty
                      //           value={
                      //             filtredurumselectValue[active_room_number]
                      //           }
                      //           onChange={FiltreDurumSelectChange}
                      //           IconComponent={() => null}
                      //         >
                      //           <MenuItem
                      //             value={
                      //               filtredurumselectValue[active_room_number]
                      //             }
                      //           >
                      //             <em>
                      //               {filtredurumselectValue[active_room_number]}
                      //             </em>
                      //           </MenuItem>
                      //         </Select>
                      //       </FormControl>
                      //     </div>
                      //   );
                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,

                      //             width: "155px",
                      //             padding: "1px 14px !important",
                      //             border: "2px solid #edbc45",
                      //             borderRadius: "4px",
                      //             color: "black",
                      //           }}
                      //           onClick={() => {
                      //             let tagId_;
                      //             state.forEach((a) => {
                      //               if (
                      //                 a[String(active_room_number)] !==
                      //                 undefined
                      //               ) {
                      //                 tagId_ =
                      //                   a[String(active_room_number)][8].tagId;
                      //               }
                      //             });
                      //             if (render_state.length > 0) {
                      //               render_state.forEach((x) => {
                      //                 if (x.tagId === String(tagId_)) {
                      //                   setfiltreselectSelectValue(
                      //                     (prevValues) => ({
                      //                       ...prevValues,
                      //                       [roomNumber]: "TEMİZ",
                      //                     })
                      //                   );
                      //                   sendSetValueFunc({
                      //                     TagId: String(tagId_),
                      //                     TagValue: x.tagValue.trim(),
                      //                   });
                      //                 }
                      //               });
                      //             }
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );

                      case "Arıza Durumu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        const arizaDurumuText =
                          değerler_eleman === "1 " ? "ARIZA" : "NORMAL";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                disabled
                                value={arizaDurumuText}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id={`oda${roomNumber}-ariza-durumu-select`}
                                className="ariza-durum-class"
                                style={{
                                  color: "rgb(47, 47, 47)",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <MenuItem value={arizaDurumuText}>
                                  <em className="ariza-durum-text">
                                    {arizaDurumuText}
                                  </em>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Arıza Kodu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        console.log(değerler_eleman);
                        const arizaKoduText =
                          {
                            1: "NORMAL",
                            2: "OTHER ERRORS",
                            3: "REFRIGERATION SYSTEM FAULT",
                            4: "WATER SYSTEM ERROR",
                            5: "AIR SYSTEM ERROR",
                            6: "ELECTRONIC SYSTEM ERROR",
                            7: "SENSOR FAULT",
                            8: "COMMUNICATION ERROR",
                            9: "SYSTEM ERROR",
                          }[değerler_eleman ? değerler_eleman.trim() : ""] ||
                          "BILINMEYEN";

                        return (
                          <div>
                            <div className={classes.statusRow}>
                              <Typography
                                variant="subtitle1"
                                className={classes.statusLabel}
                                style={{ flex: 1, textAlign: "left" }} // Yazıyı sola yaslar
                              >
                                ARIZA KODU
                              </Typography>
                              <FormControl
                                variant="outlined"
                                className={classes.formControl}
                              >
                                <Select
                                  disabled
                                  value={arizaKoduText}
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    var tagName = props.tag_list
                                      .filter((b) => b.tagId === x.tagId)
                                      .map((c) => c.tagName)[0];
                                    document.querySelector(
                                      ".show_tagName"
                                    ).innerHTML = tagName;
                                    document
                                      .querySelector(".show_external_trend")
                                      .classList.toggle(
                                        "show_external_trend_active"
                                      );
                                    document.querySelector(
                                      ".show_tagId"
                                    ).innerHTML = x.tagId;
                                    var popup = document.querySelector(
                                      ".show_external_trend"
                                    );
                                    const popupRect =
                                      popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                      newX + popupRect.width >
                                      viewportWidth
                                    ) {
                                      newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                      newY + popupRect.height >
                                      viewportHeight
                                    ) {
                                      newY = viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                      newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                      newY = 0;
                                    }

                                    // Set the position of the popup
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;
                                  }}
                                  id={`oda${roomNumber}-ariza-kodu-select`}
                                  className="ariza-durum-class"
                                  style={{
                                    color: "rgb(47, 47, 47)",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  <MenuItem value={arizaKoduText}>
                                    <em className="ariza-durum-text">
                                      {arizaKoduText}
                                    </em>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <button
                              onClick={() => {
                                let tagidsData = [];
                                initalState.forEach((a) => {
                                  Object.entries(a).forEach((x) => {
                                    if (String(active_room_number) === x[0]) {
                                      x[1].forEach((b) => {
                                        tagidsData.push({
                                          tagName: b.text,
                                          tagId: b.tagId,
                                        });
                                      });
                                    }
                                  });
                                });

                                Store.dispatch(set_combine_trends(tagidsData));
                                history.push("/raporlama");
                              }}
                              className="combine-trend_btn_vrf"
                              style={{
                                marginTop: "10px",
                                width: "100%",
                                margin: "0",
                                padding: "10px",
                              }}
                            >
                              KOMBİNE TREND
                            </button>
                            ;
                          </div>
                        );
                    }
                  })}
                </div>
              );
            }
          })}
        </div>
        {setDegerleri && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={async () => {
                  try {
                    for (let i of changed_values) {
                      let tagId, tagValue;

                      if (i === "Fan") {
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId = a[String(active_room_number)][5].tagId2;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId)) {
                              switch (
                                fanmoduselectValue[String(active_room_number)]
                              ) {
                                case "DÜŞÜK":
                                  tagValue = "1 ";
                                  break;
                                case "HIZLI":
                                  tagValue = "2 ";
                                  break;
                                case "ORTA 2":
                                  tagValue = "3 ";
                                  break;
                                case "ORTA":
                                  tagValue = "4 ";
                                  break;
                                case "AUTO":
                                  tagValue = "5 ";
                                  break;
                                default:
                                  tagValue = "5 "; // Default olarak AUTO
                              }

                              sendSetValueFunc({
                                TagId: String(tagId),
                                TagValue: tagValue,
                              });
                            }
                          });
                        }
                      } else if (i === "Çalışma") {
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId = a[String(active_room_number)][3].tagId2;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId)) {
                              switch (
                                calismamoduselectValue[
                                  String(active_room_number)
                                ]
                              ) {
                                case "ISITMA":
                                  tagValue = "2";
                                  break;
                                case "SOĞUTMA":
                                  tagValue = "1";
                                  break;
                                case "NEM ALMA":
                                  tagValue = "5";
                                  break;
                                case "FAN":
                                  tagValue = "3";
                                  break;
                                default:
                                  tagValue = "AUTO";
                              }

                              sendSetValueFunc({
                                TagId: String(tagId),
                                TagValue: tagValue,
                              });
                            }
                          });
                        }
                      } else if (i === "Cihaz") {
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId = a[String(active_room_number)][2].tagId2;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId)) {
                              tagValue =
                                cihazselectValue[String(active_room_number)] ===
                                "OFF"
                                  ? "0 "
                                  : "1 ";

                              sendSetValueFunc({
                                TagId: String(tagId),
                                TagValue: tagValue,
                              });
                            }
                          });
                        }
                      } else if (i === "SET") {
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId = a[String(active_room_number)][1].tagId;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId)) {
                              sendSetValueFunc({
                                TagId: String(tagId),
                                TagValue: String(
                                  odasetdegerler[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                        handleOdaSetDegeriDone(roomNumber);
                      } else if (i === "Soğutma") {
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId = a[String(active_room_number)][5].tagId;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId)) {
                              sendSetValueFunc({
                                TagId: String(tagId),
                                TagValue: String(
                                  sogutmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                      } else if (i === "Isıtma") {
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId = a[String(active_room_number)][6].tagId;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId)) {
                              sendSetValueFunc({
                                TagId: String(tagId),
                                TagValue: String(
                                  ısıtmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                      }
                    }

                    Set_changed_values([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };

  const [setDegerleri2, SETSetDegerleri2] = useState(false);

  const renderModalContent2 = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            Set_active_rm2(false);
            SETSetDegerleri2(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{ color: "rgb(28,28,28)" }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {"KAT-2 GENEL SİSTEM"}
        </Typography>
        <div className="vrf-popup-select">
          {Object.entries(revisedState).map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            return (
              <div style={{ width: "100%", marginRight: "16px" }}>
                {item.map((x, index) => {
                  if (index < 1) {
                    switch (item[0]) {
                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        const genel_oda_set_değeri = değerler_eleman;
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {item[0].toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                id={`oda-set-degeri-input-all`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri2(true);
                                  genel_value_changes("SET", 20);
                                  değerler_eleman = e.target.value;
                                  console.log(değerler_eleman);
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);

                        var değerler_eleman = değerler[0];

                        // Normalize cihaz durumu value
                        var normalizedCihazDurumu = değerler_eleman !== undefined ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1") : "0";

                        var cihazRengi =
                          normalizedCihazDurumu === "0" ? "gray" : "green";

                        // CihazState değerine göre yuvarlağın rengini belirleme

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor: cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.device) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                  }
                                }}
                                className="cihaz_modu_div"
                              >
                                {değerler_eleman === "0 " ? "OFF" : "ON"}
                              </div>
                              <ul className="cihaz_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    document
                                      .querySelectorAll("#cihaz_modu_div")
                                      .forEach((a) => {
                                        a.innerHTML = textCurrent;
                                      });

                                    genel_value_changes("Cihaz", textCurrent);

                                    document
                                      .querySelectorAll(
                                        ".deviceStatusIndicator"
                                      )
                                      .forEach(
                                        (a) =>
                                          (a.style.backgroundColor = "green")
                                      );

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "green";
                                  }}
                                >
                                  ON
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "gray";
                                  }}
                                >
                                  OFF
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "device")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.device ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Çalışma Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "calisma_modu_menu_active"
                                  );
                                }}
                                className="calisma_modu_div"
                              >
                                {değerler_eleman === "2 "
                                  ? "ISITMA"
                                  : değerler_eleman === "1 "
                                  ? "SOĞUTMA"
                                  : değerler_eleman === "5 "
                                  ? "NEM ALMA"
                                  : "FAN"}
                              </div>
                              <ul className="calisma_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ISITMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  SOĞUTMA
                                </li>

                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;

                                    genel_value_changes("Çalışma", textCurrent);
                                  }}
                                >
                                  NEM ALMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);
                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  FAN
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Fan Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  right: "1%",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid gray"
                                    : "2px solid rgb(23,23,23)",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                className="fan_modu_div"
                              >
                                {değerler_eleman === "1 "
                                  ? "DÜŞÜK"
                                  : değerler_eleman === "2 "
                                  ? "HIZLI"
                                  : değerler_eleman === "3 "
                                  ? "ORTA 2"
                                  : değerler_eleman === "4 "
                                  ? "ORTA"
                                  : değerler_eleman === "5 "
                                  ? "AUTO"
                                  : değerler_eleman}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    genel_value_changes("Fan", textCurrent);

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>

                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);
                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA{" "}
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Soğutma Modu Set Değeri":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(item[1][0]))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.sogutmaısıtma}>
                      //       <Grid container spacing={2} alignItems="center">
                      //         <Grid item xs={4}>
                      //           <Typography
                      //             variant="subtitle1"
                      //             className={classes.statusLabel}
                      //           >
                      //             Soğutma Modu <br /> Set Değeri :
                      //           </Typography>
                      //         </Grid>
                      //         {/* <Grid item xs={4}>
                      //           <Typography
                      //             variant="subtitle1"
                      //             className={classes.statusLabel}
                      //           >
                      //             Set Değeri <br /> Üst Limit :
                      //           </Typography>
                      //         </Grid>
                      //         <Grid item xs={4}>
                      //           <Typography
                      //             variant="subtitle1"
                      //             className={classes.statusLabel}
                      //           >
                      //             Set Değeri <br /> Alt Limit :
                      //           </Typography>
                      //         </Grid> */}
                      //       </Grid>

                      //       <Grid container spacing={2} alignItems="center">
                      //         <Grid item xs={4}>
                      //           <FormControl
                      //             variant="outlined"
                      //             className={classes.formControl}
                      //           >
                      //             <Input

                      //               labelId={`oda${roomNumber}-sogutma-modu-set-label`}
                      //               id={`oda${roomNumber}-sogutma-modu-set-input`}
                      //               sx={{ fontWeight: 600 }}
                      //               type="number"
                      //               onChange={(e) => {

                      //                 değerler_eleman = e.target.value

                      //                 handleEditStart1();
                      //                 SetsogutmamoduSet({
                      //                   201: String(değerler_eleman),
                      //                   202: String(değerler_eleman),
                      //                   203: String(değerler_eleman),
                      //                   204: String(değerler_eleman),
                      //                   205: String(değerler_eleman),
                      //                   206: String(değerler_eleman),
                      //                   207: String(değerler_eleman),
                      //                   208: String(değerler_eleman),
                      //                   209: String(değerler_eleman),
                      //                   210: String(değerler_eleman),
                      //                   211: String(değerler_eleman),
                      //                   212: String(değerler_eleman),
                      //                   213: String(değerler_eleman),
                      //                   214: String(değerler_eleman),
                      //                 })
                      //               }}
                      //               endAdornment={
                      //                 <InputAdornment position="end">
                      //                   °C
                      //                 </InputAdornment>
                      //               }
                      //             />
                      //             {/* IconButtonlar */}

                      //             <div>
                      //               {isEditing1 && (
                      //                 <>
                      //                   <IconButton
                      //                     onClick={() => {
                      //                       handleEditDone1();

                      //                       revisedState["Soğutma Modu Set Değeri"].forEach(async i => {
                      //                         await sendSetValueFunc({ TagId: i, TagValue: değerler_eleman })
                      //                       })

                      //                     }}
                      //                     size="small"
                      //                     style={{
                      //                       color: "green",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <DoneIcon />
                      //                   </IconButton>
                      //                   <IconButton
                      //                     onClick={handleEditCancel1}
                      //                     size="small"
                      //                     style={{
                      //                       color: "red",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <CancelIcon />
                      //                   </IconButton>
                      //                 </>
                      //               )}
                      //             </div>
                      //           </FormControl>
                      //         </Grid>
                      //         {/* <Grid item xs={4}>
                      //           { Soğutma Modu Üst Limit Input ve IconButtonlar }
                      //           <FormControl
                      //             variant="outlined"
                      //             className={classes.formControl}
                      //           >
                      //             <Input
                      //               labelId={`oda${roomNumber}-sogutma-modu-ust-label`}
                      //               id={`oda${roomNumber}-sogutma-modu-ust-input`}
                      //               sx={{ fontWeight: 600 }}
                      //               type="number"
                      //               value={sogutmamoduUst[roomNumber]}
                      //               onChange={(e) => {
                      //                 handleInputChange(
                      //                   roomNumber,
                      //                   "sogutmamoduUst"
                      //                 )(e);
                      //                 handleEditStart2();
                      //               }}
                      //               endAdornment={
                      //                 <InputAdornment position="end">
                      //                   °C
                      //                 </InputAdornment>
                      //               }
                      //             />
                      //             { IconButtonlar}

                      //             <div>
                      //               {isEditing2 && (
                      //                 <>
                      //                   <IconButton
                      //                     onClick={handleEditDone2}
                      //                     size="small"
                      //                     style={{
                      //                       color: "green",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <DoneIcon />
                      //                   </IconButton>
                      //                   <IconButton
                      //                     onClick={handleEditCancel2}
                      //                     size="small"
                      //                     style={{
                      //                       color: "red",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <CancelIcon />
                      //                   </IconButton>
                      //                 </>
                      //               )}
                      //             </div>
                      //           </FormControl>
                      //         </Grid>
                      //         <Grid item xs={4}>
                      //           { Soğutma Modu Alt Limit Input ve IconButtonlar }
                      //           <FormControl
                      //             variant="outlined"
                      //             className={classes.formControl}
                      //           >
                      //             <Input
                      //               labelId={`oda${roomNumber}-sogutma-modu-alt-label`}
                      //               id={`oda${roomNumber}-sogutma-modu-alt-input`}
                      //               sx={{ fontWeight: 600 }}
                      //               type="number"
                      //               value={sogutmamoduAlt[roomNumber]}
                      //               onChange={(e) => {
                      //                 handleInputChange(
                      //                   roomNumber,
                      //                   "sogutmamoduAlt"
                      //                 )(e);
                      //                 handleEditStart3();
                      //               }}
                      //               endAdornment={
                      //                 <InputAdornment position="end">
                      //                   °C
                      //                 </InputAdornment>
                      //               }
                      //             />
                      //             { IconButtonlar }

                      //             <div>
                      //               {isEditing3 && (
                      //                 <>
                      //                   <IconButton
                      //                     onClick={handleEditDone3}
                      //                     size="small"
                      //                     style={{
                      //                       color: "green",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <DoneIcon />
                      //                   </IconButton>
                      //                   <IconButton
                      //                     onClick={handleEditCancel3}
                      //                     size="small"
                      //                     style={{
                      //                       color: "red",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <CancelIcon />
                      //                   </IconButton>
                      //                 </>
                      //               )}
                      //             </div>
                      //           </FormControl>
                      //         </Grid> */}
                      //       </Grid>
                      //     </div>
                      //   );
                      // case "Isıtma Modu Set Değeri":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(item[1][0]))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.sogutmaısıtma}>
                      //       <Grid container spacing={2} alignItems="center">
                      //         <Grid item xs={4}>
                      //           <Typography
                      //             variant="subtitle1"
                      //             className={classes.statusLabel}
                      //           >
                      //             Isıtma Modu <br /> Set Değeri :
                      //           </Typography>
                      //         </Grid>
                      //         {/* <Grid item xs={4}>
                      //           <Typography
                      //             variant="subtitle1"
                      //             className={classes.statusLabel}
                      //           >
                      //             Set Değeri <br /> Üst Limit :
                      //           </Typography>
                      //         </Grid>
                      //         <Grid item xs={4}>
                      //           <Typography
                      //             variant="subtitle1"
                      //             className={classes.statusLabel}
                      //           >
                      //             Set Değeri <br /> Alt Limit :
                      //           </Typography>
                      //         </Grid> */}
                      //       </Grid>

                      //       <Grid container spacing={2} alignItems="center">
                      //         <Grid item xs={4}>
                      //           <FormControl
                      //             variant="outlined"
                      //             className={classes.formControl}
                      //           >
                      //             <Input

                      //               labelId={`oda${roomNumber}-ısıtma-modu-set-label`}
                      //               id={`oda${roomNumber}-ısıtma-modu-set-input`}
                      //               sx={{ fontWeight: 600 }}
                      //               type="number"
                      //               onChange={(e) => {
                      //                 değerler_eleman = e.target.value
                      //                 handleEditStart4();
                      //                 SetısıtmamoduSet({
                      //                   201: String(değerler_eleman),
                      //                   202: String(değerler_eleman),
                      //                   203: String(değerler_eleman),
                      //                   204: String(değerler_eleman),
                      //                   205: String(değerler_eleman),
                      //                   206: String(değerler_eleman),
                      //                   207: String(değerler_eleman),
                      //                   208: String(değerler_eleman),
                      //                   209: String(değerler_eleman),
                      //                   210: String(değerler_eleman),
                      //                   211: String(değerler_eleman),
                      //                   212: String(değerler_eleman),
                      //                   213: String(değerler_eleman),
                      //                   214: String(değerler_eleman),
                      //                 })
                      //               }}
                      //               endAdornment={
                      //                 <InputAdornment position="end">
                      //                   °C
                      //                 </InputAdornment>
                      //               }
                      //             />
                      //             {/* IconButtonlar */}

                      //             <div>
                      //               {isEditing4 && (
                      //                 <>
                      //                   <IconButton
                      //                     onClick={() => {
                      //                       handleEditDone4();
                      //                       revisedState["Isıtma Modu Set Değeri"].forEach(async i => {
                      //                         await sendSetValueFunc({ TagId: i, TagValue: değerler_eleman })
                      //                       })
                      //                     }}
                      //                     size="small"
                      //                     style={{
                      //                       color: "green",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <DoneIcon />
                      //                   </IconButton>
                      //                   <IconButton
                      //                     onClick={handleEditCancel4}
                      //                     size="small"
                      //                     style={{
                      //                       color: "red",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <CancelIcon />
                      //                   </IconButton>
                      //                 </>
                      //               )}
                      //             </div>
                      //           </FormControl>
                      //         </Grid>
                      //         {/* <Grid item xs={4}>
                      //           <FormControl
                      //             variant="outlined"
                      //             className={classes.formControl}
                      //           >
                      //             <Input
                      //               labelId={`oda${roomNumber}-ısıtma-modu-ust-label`}
                      //               id={`oda${roomNumber}-ısıtma-modu-ust-input`}
                      //               sx={{ fontWeight: 600 }}
                      //               type="number"
                      //               value={ısıtmamoduUst[roomNumber]}
                      //               onChange={(e) => {
                      //                 handleInputChange(
                      //                   roomNumber,
                      //                   "ısıtmamoduUst"
                      //                 )(e);
                      //                 handleEditStart5();
                      //               }}
                      //               endAdornment={
                      //                 <InputAdornment position="end">
                      //                   °C
                      //                 </InputAdornment>
                      //               }
                      //             />
                      //             { IconButtonlar }

                      //             <div>
                      //               {isEditing5 && (
                      //                 <>
                      //                   <IconButton
                      //                     onClick={handleEditDone5}
                      //                     size="small"
                      //                     style={{
                      //                       color: "green",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <DoneIcon />
                      //                   </IconButton>
                      //                   <IconButton
                      //                     onClick={handleEditCancel5}
                      //                     size="small"
                      //                     style={{
                      //                       color: "red",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <CancelIcon />
                      //                   </IconButton>
                      //                 </>
                      //               )}
                      //             </div>
                      //           </FormControl>
                      //         </Grid>
                      //         <Grid item xs={4}>
                      //           <FormControl
                      //             variant="outlined"
                      //             className={classes.formControl}
                      //           >
                      //             <Input
                      //               labelId={`oda${roomNumber}-ısıtma-modu-alt-label`}
                      //               id={`oda${roomNumber}-ısıtma-modu-alt-input`}
                      //               sx={{ fontWeight: 600 }}
                      //               type="number"
                      //               value={ısıtmamoduAlt[roomNumber]}
                      //               onChange={(e) => {
                      //                 handleInputChange(
                      //                   roomNumber,
                      //                   "ısıtmamoduAlt"
                      //                 )(e);
                      //                 handleEditStart6();
                      //               }}
                      //               endAdornment={
                      //                 <InputAdornment position="end">
                      //                   °C
                      //                 </InputAdornment>
                      //               }
                      //             />
                      //             { IconButtonlar }

                      //             <div>
                      //               {isEditing6 && (
                      //                 <>
                      //                   <IconButton
                      //                     onClick={handleEditDone6}
                      //                     size="small"
                      //                     style={{
                      //                       color: "green",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <DoneIcon />
                      //                   </IconButton>
                      //                   <IconButton
                      //                     onClick={handleEditCancel6}
                      //                     size="small"
                      //                     style={{
                      //                       color: "red",
                      //                       marginLeft: "5px",
                      //                     }}
                      //                   >
                      //                     <CancelIcon />
                      //                   </IconButton>
                      //                 </>
                      //               )}
                      //             </div>
                      //           </FormControl>
                      //         </Grid> */}
                      //       </Grid>
                      //     </div>
                      //   );
                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(item[1][0]))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {item[0].toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,
                      //             height: "2.5rem",

                      //             width: "10rem",
                      //             fontSize: "1rem",
                      //             border: "2px solid #edbc45",
                      //             borderRadius: "4px",
                      //             color: "gray",
                      //           }}
                      //           onClick={() => {
                      //             değerler_eleman = değerler_eleman.slice(
                      //               0,
                      //               -1
                      //             );
                      //             revisedState["Filtre Reset"].forEach(
                      //               async (i) => {
                      //                 await sendSetValueFunc({
                      //                   TagId: i,
                      //                   TagValue: değerler_eleman,
                      //                 });
                      //               }
                      //             );
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );
                    }
                  }
                })}
              </div>
            );
          })}
        </div>
        {setDegerleri2 && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  console.log("aa");
                  try {
                    for (let i of changed_values2) {
                      console.log(i);
                      if (i.type === "Fan") {
                        // Fan Modu
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Fan Modu") {
                                let tagValue;

                                // Fan değerlerini belirle
                                switch (i.value) {
                                  case "DÜŞÜK":
                                    tagValue = "1 ";
                                    break;
                                  case "HIZLI":
                                    tagValue = "2 ";
                                    break;
                                  case "ORTA 2":
                                    tagValue = "3 ";
                                    break;
                                  case "ORTA":
                                    tagValue = "4 ";
                                    break;
                                  case "AUTO":
                                    tagValue = "5 ";
                                    break;
                                  default:
                                    tagValue = "5 "; // Default olarak AUTO
                                }

                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: tagValue,
                                });
                              }
                            });
                          });

                          // Fan seçilen değerleri güncelle
                          const fanValue = i.value === "5" ? "AUTO" : i.value;
                          setfanmoduSelectValue({
                            201: fanValue,
                            202: fanValue,
                            203: fanValue,
                            204: fanValue,
                            205: fanValue,
                            206: fanValue,
                            207: fanValue,
                            208: fanValue,
                            209: fanValue,
                            210: fanValue,
                            211: fanValue,
                            212: fanValue,
                            213: fanValue,
                            214: fanValue,
                          });
                        });
                      } else if (i.type === "Çalışma") {
                        //Çalışma Modu

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Çalışma Modu") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "ISITMA"
                                      ? "2 "
                                      : i.value === "SOĞUTMA"
                                      ? "1 "
                                      : i.value === "NEM ALMA"
                                      ? "5 "
                                      : "3 "
                                  ),
                                });
                              }
                            });
                          });
                          setcalismamoduSelectValue({
                            201: i.value,
                            202: i.value,
                            203: i.value,
                            204: i.value,
                            205: i.value,
                            206: i.value,
                            207: i.value,
                            208: i.value,
                            209: i.value,
                            210: i.value,
                            211: i.value,
                            212: i.value,
                            213: i.value,
                            214: i.value,
                          });
                        });
                      } else if (i.type === "Cihaz") {
                        //Cihaz
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Cihaz") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "OFF" ? "0 " : "1 "
                                  ),
                                });
                              }
                            });
                          });
                          setcihazSelectValue({
                            201: i.value,
                            202: i.value,
                            203: i.value,
                            204: i.value,
                            205: i.value,
                            206: i.value,
                            207: i.value,
                            208: i.value,
                            209: i.value,
                            210: i.value,
                            211: i.value,
                            212: i.value,
                            213: i.value,
                            214: i.value,
                          });
                          Setcihazled({
                            201: i.value === "ON" ? "green" : "gray",
                            202: i.value === "ON" ? "green" : "gray",
                            203: i.value === "ON" ? "green" : "gray",
                            204: i.value === "ON" ? "green" : "gray",
                            205: i.value === "ON" ? "green" : "gray",
                            206: i.value === "ON" ? "green" : "gray",
                            207: i.value === "ON" ? "green" : "gray",
                            208: i.value === "ON" ? "green" : "gray",
                            209: i.value === "ON" ? "green" : "gray",
                            210: i.value === "ON" ? "green" : "gray",
                            211: i.value === "ON" ? "green" : "gray",
                            212: i.value === "ON" ? "green" : "gray",
                            213: i.value === "ON" ? "green" : "gray",
                            214: i.value === "ON" ? "green" : "gray",
                          });
                        });
                      } else if (i.type === "SET") {
                        //Oda Set Değeri
                        let value_all_set = document.querySelector(
                          "#oda-set-degeri-input-all"
                        ).value;

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Oda Set Değeri") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId),
                                  TagValue: String(value_all_set),
                                });
                              }
                            });
                          });
                        });

                        setOdasetdegerler({
                          201: String(value_all_set),
                          202: String(value_all_set),
                          203: String(value_all_set),
                          204: String(value_all_set),
                          205: String(value_all_set),
                          206: String(value_all_set),
                          207: String(value_all_set),
                          208: String(value_all_set),
                          209: String(value_all_set),
                          210: String(value_all_set),
                          211: String(value_all_set),
                          212: String(value_all_set),
                          213: String(value_all_set),
                          214: String(value_all_set),
                        });
                      }
                    }
                    Set_changed_values2([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri2(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri2(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const getTagIdForRoomCihaz = (roomNumber) => {
    const tagIdMap = {
      201: "5450",
      202: "5454",
      203: "5458",
      204: "5462",
      205: "5466",
      206: "5470",
      207: "5474",
      208: "5478",
      209: "5482",
      210: "5486",
      211: "5490",
      212: "5494",
      213: "5498",
      214: "5502",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomOperationMode = (roomNumber) => {
    const tagIdMap = {
      201: "6731",
      202: "6735",
      203: "6739",
      204: "6743",
      205: "6747",
      206: "6751",
      207: "6755",
      208: "6759",
      209: "6763",
      210: "6767",
      211: "6771",
      212: "6775",
      213: "6779",
      214: "6783",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomSetDeger = (roomNumber) => {
    const tagIdMap = {
      201: "5244",
      202: "5250",
      203: "5256",
      204: "5262",
      205: "5268",
      206: "5274",
      207: "5280",
      208: "5286",
      209: "5292",
      210: "5298",
      211: "5304",
      212: "5310",
      213: "5316",
      214: "5322",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAnlik = (roomNumber) => {
    const tagIdMap = {
      201: "5055",
      202: "5056",
      203: "5057",
      204: "5058",
      205: "5059",
      206: "5060",
      207: "5061",
      208: "5062",
      209: "5063",
      210: "5064",
      211: "5065",
      212: "5066",
      213: "5067",
      214: "5068",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAriza = (roomNumber) => {
    const arizaTagIdMap = {
      201: "8643",
      202: "8647",
      203: "8651",
      204: "8655",
      205: "8659",
      206: "8663",
      207: "8667",
      208: "8671",
      209: "8675",
      210: "8679",
      211: "8683",
      212: "8687",
      213: "8691",
      214: "8695",
    };
    return arizaTagIdMap[roomNumber] || null;
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className={classes.pageroot + " arkaplan"}>
        <div className={classes.topButtonContainer}>
          <button
            onClick={() => {
              Set_active_rm2(true);
            }}
            className="kat-bazı kat_bazı_vrf5"
          >
            KAT - 2
          </button>
        </div>

        {active_rm2 && (
          <div key={"sistem1"}>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={true}
              onClose={() => {}}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              {renderModalContent2("Sistem Kat-2")}
            </Modal>
          </div>
        )}
        <div className="move-main-vrf">
          <Link to="/VRF">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              ANA EKRAN
            </Button>
          </Link>
        </div>
        <div className="page-move-vrf">
          <Link to="/vrf1">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              Geri
            </Button>
          </Link>
          <Link to="/vrf3">
            <Button
              className={classes.navigationButtonForward + " movebuttonsvrf"}
              variant="contained"
            >
              İleri
            </Button>
          </Link>
        </div>

        <div className={classes.buttonContainer}>
          {open.map((isOpen, index) => {
            const roomNumber = 201 + index;
            const roomClass = `vrf-oda${roomNumber}`;

            // Cihaz durumunu belirleyen tagId
            const tagId = getTagIdForRoomCihaz(roomNumber);

            // Operation mode'ı belirleyen tagId
            const operationModeTagId = getTagIdForRoomOperationMode(roomNumber);

            // Set değerini belirleyen tagId
            const setDegerTagId = getTagIdForRoomSetDeger(roomNumber);

            // Yeni değeri belirleyen tagId
            const anlikTagId = getTagIdForRoomAnlik(roomNumber);

            // Arıza durumunu gösteren tagId
            const arizaTagId = getTagIdForRoomAriza(roomNumber);

            // Cihaz durumunu belirleyen render_state değerleri
            const değerler = render_state
              .filter((a) => String(a.tagId) === tagId)
              .map((b) => b.tagValue);
            const değerler_eleman = değerler[0];

            // Normalize cihaz durumu value
            const normalizedCihazDurumu = değerler_eleman !== undefined ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1") : "0";

            const cihazDurumuText = normalizedCihazDurumu === "0" ? "OFF" : "ON";
            let cihazRengi =
              normalizedCihazDurumu === "0" ? "lightgray" : "rgb(237, 188, 69)";

            // Arıza durumunu belirleyen render_state değerleri
            const arizaDeğerler = render_state
              .filter((a) => String(a.tagId) === arizaTagId)
              .map((b) => b.tagValue);
            const arizaDurumu = arizaDeğerler[0];

            // Normalize ariza durumu value
            const normalizedArizaDurumu = arizaDurumu !== undefined ? (Number(arizaDurumu.toString().trim()) === 1 ? "1" : "0") : "0";

            // Eğer arıza durumu '1' ise cihaz rengi kırmızıya ayarlanır
            if (normalizedArizaDurumu === "1") {
              cihazRengi = "red";
            }

            // Operation mode'unu belirleyen render_state değerleri
            const operationModeDeğerler = render_state
              .filter((a) => String(a.tagId) === operationModeTagId)
              .map((b) => b.tagValue);
            const operationModeDeğer = operationModeDeğerler[0];

            // Normalize operation mode value
            const normalizedOperationMode = operationModeDeğer !== undefined ? String(Math.round(Number(operationModeDeğer.toString().trim()))) : "0";

            // Set değerini belirleyen render_state değerleri
            const setDegerDeğerler = render_state
              .filter((a) => String(a.tagId) === setDegerTagId)
              .map((b) => b.tagValue);
            const setDeger = setDegerDeğerler[0];

            // Yeni değerini belirleyen render_state değerleri
            const newValueDeğerler = render_state
              .filter((a) => String(a.tagId) === anlikTagId)
              .map((b) => b.tagValue);
            const newValue = newValueDeğerler[0];

            // Operation mode'a göre renk ayarla
            let operationModeRengi = "gray"; // Varsayılan gri
            if (normalizedOperationMode === "1") {
              operationModeRengi = "cornflowerblue";
            } else if (normalizedOperationMode === "2") {
              operationModeRengi = "red";
            }

            return (
              <div key={roomNumber} className="vrf-buttonlar">
                <Button
                  className={`${classes.button} ${roomClass} vrfbuttons`}
                  onClick={() => {
                    Set_active_room_number(roomNumber);
                    handleOpen(index);
                  }}
                  style={{
                    backgroundColor: cihazRengi || cihazled[String(roomNumber)],
                  }}
                >
                  {`${roomNumber} `}

                  {/* Yeni değer için div */}
                  <span
                    style={{
                      position: "absolute",
                      right: "52%",
                      top: "40%",
                      border: "1px solid black",
                      padding: "4px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}
                  >
                    {`ODA : ${newValue} °C`}
                  </span>

                  <div
                    className="operationmodeIndicator"
                    style={{
                      display: "inline-block",
                      backgroundColor: operationModeRengi,
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      marginLeft: "15%",
                      marginTop: "15%",
                    }}
                  ></div>

                  {/* SET : "değer" kısmı */}
                  <span
                    style={{
                      position: "absolute",
                      left: "67%",
                      top: "40%",
                      border: "1px solid black",
                      borderRadius: "5px",
                      padding: "4px",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}
                  >
                    {`SET : ${setDeger}`}
                  </span>
                </Button>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.modal}
                  open={isOpen}
                  onClose={() => handleClose(index)}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  {renderModalContent(roomNumber)}
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    vrf2_tags: state.project_reducer.vrf2_tags,
    tag_list: state.project_reducer.tag_list,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    uid: state.auth_reducer.user_id,
  };
};

export default connect(MapStateToProps)(VRF2);
